import React from "react";
import "./TruckCapacitySelector.css";

interface TruckCapacitySelectorProps {
    selectedIndex: number;
    onChange: (index: number) => void;
    title?: string;
    tooltip?: React.ReactNode;
}

const TruckCapacitySelector: React.FC<TruckCapacitySelectorProps> = ({
    selectedIndex,
    onChange,
    title,
    tooltip
}) => {
    const options = [
        {
            icon: require("../../assets/Icon/TruckCapacity_MANUAL.png"),
            label: "Manual",
            index: 0
        },
        {
            icon: require("../../assets/Icon/TruckCapacity_SMALL.png"),
            label: "Small (<5 m³)",
            index: 1
        },
        {
            icon: require("../../assets/Icon/TruckCapacity_MEDIUM.png"),
            label: "Medium (5 - 10 m³)",
            index: 2
        },
        {
            icon: require("../../assets/Icon/TruckCapacity_LARGE.png"),
            label: "Large (> 10 m³)",
            index: 3
        }
    ];

    return (
        <div className="truck-capacity-selector">
            {title && (
                <div className="truck-capacity-title-row">
                    <h4 className="truck-capacity-title">{title}</h4>
                    {tooltip}
                </div>
            )}
            <div className="truck-capacity-buttons">
                {options.map((option) => (
                    <button
                        key={option.index}
                        className={`truck-capacity-button ${selectedIndex === option.index ? "truck-capacity-button--selected" : ""
                            }`}
                        onClick={() => onChange(option.index)}
                    >
                        <div className="truck-capacity-icon">
                            <img src={option.icon} alt={option.label} />
                        </div>
                        <span className="truck-capacity-label">{option.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TruckCapacitySelector;
